import React, { memo } from 'react'
import { View, Dimensions, ViewStyle, TextStyle, Image } from 'react-native'
import { Text } from '../text'
import LinearGradient from 'react-native-linear-gradient'

export const Level = (props: any) => {
  const { style, levelUp = false, textStyle, text, level_icon, iconW, iconH } = props
  if (level_icon) {
    return (
      <View style={{ ...DEFAULT_STYLE, ...style, marginTop: 1 }}>
        <Image
          style={{ ...DEFAULT_STYLE, ...style }}
          source={{ uri: level_icon }}
          width={iconW || 32}
          height={iconH || 32}
        />
      </View>
    )
  }
  return (
    <View style={{ ...DEFAULT_STYLE, ...style, marginTop: 1 }}>
      {levelUp && (
        <LinearGradient
          colors={['#000', '#fff']}
          useAngle
          angle={-10}
          style={{
            opacity: 0.35,
            height: 28,
            width: 34,
            top: -2,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 40,
            position: 'absolute',
          }}
        />
      )}
      <Text
        variant="labelEmphasized"
        style={{
          fontSize: 14,
          bottom: 0,
          ...textStyle,
        }}
      >
        {text}
      </Text>
    </View>
  )
}

const DEFAULT_STYLE: ViewStyle = {
  borderRadius: Math.round(Dimensions.get('window').width + Dimensions.get('window').height) / 2,
  backgroundColor: '#fff',
  justifyContent: 'center',
  alignItems: 'center',
}
